/** @module appSelectors */
import _get from 'lodash/get';
import { getTimestamp, getMsTimestamp } from '@bedrock-rdk/utils/src/time';

const DEFAULT_ARRAY = [];
const DEFAULT_OBJECT = {};

export const getAppState = ({ app }) => app;

/**
 * @function
 * @summary Is the application initializing or not
 * @param {boolean} initializing
 * @returns {boolean}
 */
export const isAppInitializing = ({ app: { initializing } }) => initializing;

/**
 * @function
 * @summary Is the application initialized or not
 * @param {boolean} initialized
 * @returns {boolean}
 */
export const isAppInitialized = ({ app: { initialized } }) => initialized;

export const getAnalytics = state => _get(state, 'app.analytics');

export const getAnalyticsEngines = state => _get(state, 'app.analytics.engines', DEFAULT_ARRAY);

export const getAnalyticsEvents = state => {
  const enabledEngines = getAnalyticsEngines(state);
  const taggingPlans = _get(state, 'app.analytics.taggingPlans', DEFAULT_OBJECT);

  return Object.keys(taggingPlans).reduce((result, key) => {
    if (enabledEngines.indexOf(key) === -1) {
      return result;
    }
    result = { ...result, ...taggingPlans[key] };

    return result;
  }, {});
};

export const getDeviceBrand = state => _get(state, 'app.deviceBrand');

export const getDeviceModel = state => _get(state, 'app.deviceModel');

export const getDeviceVersion = state => _get(state, 'app.deviceVersion');

export const isScreensaverVisible = ({ screensaver: { displayScreenSaver } }) => displayScreenSaver;

export const getCurrentTime = ({ app: { serverTime, initialElapsedTime } }) =>
  getTimestamp(serverTime, initialElapsedTime);

export const getCurrentMsTime = ({ app: { serverTime, initialElapsedTime } }) =>
  getMsTimestamp(serverTime, initialElapsedTime);

export const getServerTime = ({ app: { serverTime } }) => serverTime;

export const getInitialElapsedTime = ({ app: { initialElapsedTime } }) => initialElapsedTime;

export const getStartoverMinDepth = ({ app: { startoverMinDepth } }) => startoverMinDepth;

export const getStartoverMaxDepth = ({ app: { startoverMaxDepth } }) => startoverMaxDepth;

export const getStartoverMinPercentage = ({ app: { startoverMinPercentage } }) => startoverMinPercentage;

export const getStartoverMaxPercentage = ({ app: { startoverMaxPercentage } }) => startoverMaxPercentage;

export const isConnected = state => getAppState(state).connected;

export const getScreenSize = ({ app: { screenSize } }) => screenSize;

export const getRetriesCount = state => state.app.initializeRetriesCount;

export const getGivenConsentVersion = state => state.app.givenConsentVersion;
